import React from 'react';
import { appInfo } from 'app-info';
import styles from './footer.module.scss';

type FooterProps = {
  compactMode?: boolean;
  currentYear?: number; // Для тестування або кастомних значень
};

export const Footer: React.FC<FooterProps> = ({ compactMode=false, currentYear = new Date().getFullYear() }) => {

  if (compactMode) {
    return (
      <footer className={`${styles.footer} footer--compact`}>
        <span>©</span>{currentYear}
      </footer>
    );
  }
  return (
    <footer className={styles.footer}>
      Copyright © 2020-{currentYear}<br/>{appInfo.title}<br/>
      {` (v${appInfo.version})`}
      <br />
      All trademarks or registered trademarks are property of their
      respective owners.
    </footer>
  );
};

